var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-area',{attrs:{"title":"Causas externas (Acidentes ou violências)"}},[_c('Form',{attrs:{"form":_vm.form,"model":_vm.model}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }